// Web API 'MutationObserver' : https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver

// Select 'body' node that will be observed for mutations, because intercom add inline css to 'body'
const targetNode = document.getElementsByTagName('body');

// which mutations to observe
const config = { attributes: true, attributeFilter: ["style"]};

// Callback function adapt header 'top' position
const mutationCallback = function(mutationList, observer) {
    // Use traditional 'for loops' for IE 11
    for(const mutation of mutationList) {
      const intercomBanner = $('.intercom-namespace > .intercom-app > iframe[name="intercom-banner-frame"]');
      if( intercomBanner.length !== 0 ){
        let intercomBannerheight = intercomBanner.css('height');
        if (intercomBannerheight == '0px') {
          intercomBannerheight = '50px';
        }
        $('body > header').css('top', intercomBannerheight);
      }else{
        $('body > header').css('top', '0');
      }
    }
};

// Create the observer instance then start observing
const observer = new MutationObserver(mutationCallback);
observer.observe(targetNode[0], config);
